import NumberFormatOptions = Intl.NumberFormatOptions

const preventNegativeZero = (number: number) => {
  return Object.is(number, -0) ? 0 : number
}

export function formatCurrency(price: number, currencyCode = 'JPY') {
  if (typeof price !== 'number') return '-'

  const num = Object.is(price, -0) ? 0 : price

  const options: NumberFormatOptions = {
    currency: currencyCode,
    style: 'currency',
  }

  return new Intl.NumberFormat('ja-JP', options).format(num)
}

export function formatCurrencyPlusOrNon(value: number, currencyCode = 'JPY') {
  if (typeof value !== 'number') return '-'

  const sign = value > 0 ? '+' : ''

  const options: NumberFormatOptions = {
    style: 'currency',
    currency: currencyCode,
  }

  return (
    sign +
    new Intl.NumberFormat('ja-JP', options).format(
      Math.abs(preventNegativeZero(value))
    )
  )
}

// Convert currency codes into respective symbols.
// ex) EUR => €
export function getCurrencySymbol(currencyCode: string): string {
  try {
    const formatted = new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: currencyCode,
    }).format(0)
    const m = formatted.match(/^[0\s.]*(.*?)[0\s.]*$/)
    return m && m.length >= 2 ? m[1] : currencyCode
  } catch (e) {
    return currencyCode
  }
}

// Format to comma separated number
export function formatJpyWithCommas(number: number) {
  if (!number) return '0'
  return new Intl.NumberFormat('ja-JP').format(preventNegativeZero(number))
}

// Format Number to Currency (plus sign or minus sign)
export function formatCurrencyPlusOrMinus(
  number: number,
  currencyCode = 'JPY'
): string {
  if (typeof number !== 'number') return '-'

  const sign = number > 0 ? '+' : ''

  const options: NumberFormatOptions = {
    style: 'currency',
    currency: currencyCode,
  }

  return (
    sign +
    new Intl.NumberFormat('ja-JP', options).format(preventNegativeZero(number))
  )
}
